import React, { useMemo } from "react"
import PropTypes from "prop-types"
import Spinner from "components/common/Spinner"
import styles from "../../index.module.css"
import CalendarTimeGrid from "../../CalendarTimeGrid"

/**
 * Day View Component - Data Driven
 * Accepts pre-filtered bookings data as prop
 */
const Day = ({ date, bookingsData = [], journalNoteDates = [], loading = false, onJournalClick, canCreateJournal = true, canEditJournal = true, canViewJournal = true }) => {
  const events = useMemo(() => {
    return bookingsData?.map((booking) => ({
      id: booking?.uuid,
      start: booking?.formatted_start_time,
      end: booking?.formatted_end_time,
      title: booking?.title,
      date: booking?.formatted_date,
      payment_status: booking?.payment_status,
      color: booking?.color,
    }))
  }, [bookingsData])

  return (
    <>
      <CalendarTimeGrid date={date} events={events} type="day" journalNoteDates={journalNoteDates} onJournalClick={onJournalClick} canCreateJournal={canCreateJournal} canEditJournal={canEditJournal} canViewJournal={canViewJournal} />
      {loading && <Spinner className={styles.spinner} absolute />}
    </>
  )
}

Day.propTypes = {
  date: PropTypes.string.isRequired,
  bookingsData: PropTypes.array,
  journalNoteDates: PropTypes.array,
  loading: PropTypes.bool,
  onJournalClick: PropTypes.func,
  canCreateJournal: PropTypes.bool,
  canEditJournal: PropTypes.bool,
  canViewJournal: PropTypes.bool
}

export default Day
